module.exports = __webpack_public_path__ + "static/media/bgPiloto.999fed1a.png";